import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import './gridButtons.scss'
import { Responsive, WidthProvider } from "react-grid-layout";
import '../../../../node_modules/react-grid-layout/css/styles.css'
import '../../../../node_modules/react-resizable/css/styles.css'
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Icon, { IconSize, IconType } from '../../atoms/icon/icon';
import { useEffect } from 'react';
import FormMultipleRelationship from '../../organisms/formMultipleRelationship/formMultipleRelationship';
import { isEmpty } from 'lodash';
import swal from 'sweetalert';
import sportRoomIcon from '../../atoms/customIcons/sportRoomIcon.svg'; 
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import staticImageIcon from '../../atoms/customIcons/staticImageIcon.svg';
import highlightedContentIcon from '../../atoms/customIcons/highlightedContentIcon.svg';
import externalVideoIcon from '../../atoms/customIcons/externalVideoIcon.svg';
import carouselIcon from '../../atoms/customIcons/carouselIcon.svg';
import spacesCarouselIcon from '../../atoms/customIcons/spacesCarouselIcon.svg';
import contentCategoryIcon from '../../atoms/customIcons/contentCategoryIcon.svg';
import interactableGraphicsIcon from '../../atoms/customIcons/interactableGraphicsIcon.svg';
import app2appTravelIcon from '../../atoms/customIcons/contentApp2AppTravelIcon.svg';

const ResponsiveGridLayout = WidthProvider(Responsive);


const GridButtons = (props) => {
  const {
    value,
    onNewContent
  } = props;
  const handleSelectOption=(e,option)=>{
    onNewContent({"gridButtons":option});
  }
  useEffect(() => {
  }, []);
  const getType=(type,returnName=false)=>{
    switch(type){
      case "sportRoom":
        if(returnName)
          return "Room";
        return <img src={sportRoomIcon} />;
      break;
      case "staticImage":
        if(returnName)
          return "Static graphic";
        return <img src={staticImageIcon} />;
        break;
      case "calendar":
        if(returnName)
          return "Calendar icon";
        return <img src={calendarIcon} />;
      break;
      case "highlightedContent":
        if(returnName)
          return "Video";
          
        return <img src={highlightedContentIcon} />;
        break;
      case "carousel":
        if(returnName)
          return "Carousel";
          
        return <img src={carouselIcon} />;
      break;
       case "spacesCarousel":
        if(returnName)
          return "Spaces  Carousel";
        return <img src={spacesCarouselIcon} />;
      break;
      case "interactableGraphics":
        if(returnName)
          return "Interactable graphic";
          
        return <img src={interactableGraphicsIcon} />;
        break;
      case "contentCategory":
        if(returnName)
          return "Content category";
          
        return <img src={contentCategoryIcon} />;
        break;
      case "App2AppTravel":
        if(returnName)
          return "App2App travel";
        return <img src={app2appTravelIcon} />;
        break;
    }
  }
 
  return (
     <div className='gridButtons lightColor'>
        {value &&  Object.keys(value).map((button,index)=>{
            return (<div key={index} className='gridElements'>
            <div className="gridContent">
                <div className="buttonContainer">
                <button
                    id={"layout-popup-content--"+value[button].id}
                    type="button"
                    // onClick={playOrPause}
                    className="buttonGrid"
                    onClick={(e)=>handleSelectOption(e,value[button].id)}
                >
                {getType(value[button].id)}
                <br/>
                {value[button].name}
                </button>
                    </div>
            </div>
        </div>); 
        })}
      </div>
  );
};

GridButtons.propTypes = {
  className: PropTypes.string,
      /**
   * Data set change event
   */
//   onChange: PropTypes.func,
//   onRemovePanel: PropTypes.func,
};

GridButtons.defaultProps = {
//   className: '',
//   onChange: () => {},
//   onRemovePanel: () => {},
};

export default GridButtons;
